import { CRTMSG, DELMSG, UPTMSG } from 'src/Helper/toastmsg';
import {
  RECEIPT_CREATE, RECEIPT_LIST, RECEIPT_NUMBER, RECEIPT_SINGLE,
  RECEIPT_UPDATE, RECEIPT_DELETE, RECEIPT_CUSTINV, RECEIPT_SEND,
  RECEIPT_PARTICULAR, RECEIPT_TOTALS,
  CLEAR_RECEIPT_TEMP_STATES, CLEAR_RECEIPT_STATES, LEDGER_LIST_ACCOUNTS, FETCH_LEDGER_R, FETCH_LEDGER_E,
} from './../../../../Helper/actionsTypes';

const receiptReducer = (state = {}, action) => {
  const {  code, results, message } = action.payload || ''
  switch (action.type) {
    case RECEIPT_PARTICULAR: {
      return { ...state, particular: action.payload };
    }
    case RECEIPT_TOTALS: {
      return { ...state, totals: action.payload };
    }
    case RECEIPT_LIST: {
      return code === 200
        ? { ...state, list: results }
        : { ...state, list: [] };
    }
    case RECEIPT_CUSTINV: {
      return code === 200
        ? { ...state, custInv: results }
        : { ...state, custInv: [] };
    }
    case 'RECEIPT_CUSTINV_UPT': {
      return  { ...state, custInv: action.payload }
    }
    case RECEIPT_NUMBER: {
      return code === 200
        ? { ...state, number: results.receipt_no }
        : { ...state, number: null };
    }
    case FETCH_LEDGER_R: {
      return code === 200
        ? { ...state, ledgerR: results }
        : { ...state, ledgerR: [] }
    }
    case FETCH_LEDGER_E: {
      return code === 200
        ? { ...state, ledgerE: results }
        : { ...state, ledgerE: [] } 
    }
    case LEDGER_LIST_ACCOUNTS: {
      return code === 200
        ? { ...state, ledgerAccount: results }
        : { ...state, ledgerAccount: '' }
    }
    case RECEIPT_SINGLE: {
      return code === 200
        ? { ...state, single: results }
        : { ...state, single: [] };
    }
    case RECEIPT_SEND: {
      return code === 200
        ? { ...state, sent: true }
        : { ...state, sent: false };
    }
    case RECEIPT_DELETE: {
      return code === 200
        ? { ...state, itemDeleted: true, message }
        : code === 500 ? { ...state, itemDeleted: true, message: DELMSG }
          : { ...state, itemDeleted: false, message };
    }
    case RECEIPT_CREATE: {
      return code === 200 ? { ...state, itemSaved: true, message }
        : code === 500 ? { ...state, itemSaved: false, message: CRTMSG }
          : { ...state, itemSaved: false, message };
    }

    case RECEIPT_UPDATE: {
      return code === 200
        ? { ...state, itemUpdated: true, message }
        : code === 500 ? { ...state, itemUpdated: false, message: UPTMSG }
          : { ...state, itemUpdated: false, message }
    }
    case CLEAR_RECEIPT_TEMP_STATES: return {
      ...state,
      sent: null,
      itemDeleted: null,
      itemSaved: null,
      itemUpdated: null,
      message: null,
      custInv: [],
      ledgerR: [],
      ledgerE:[]
    };
    case CLEAR_RECEIPT_STATES: return {
      particular: [],
      totals: { qty: 0, amount: 0 },
    };
    default: return state;
  }
};

export default receiptReducer;